import { action, makeObservable, observable } from 'mobx';
import { MODO_PARTICIPACAO_ADVOGADO } from '../../dominio/ModoParticipacaoAdvogado';
import { Filtro, TIPO_CONJUNTO_OPCOES_FILTRO } from './Filtro';

export default class FiltroAdvogadoPreferenciaSustentacaoOralUfOab extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    /**
     * @type {Set}
     */
    opcoes = new Set();

    /**
     * @type {string}
     */
    static opcaoSemValor = 'Não informada';

    get label() {
        return 'UF de OAB de advogados inscritos para preferência/sustentação oral';
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            opcoes: observable,
            getValorOpcao: action
        });
    }

    get tipoConjuntoOpcoes() {
        return TIPO_CONJUNTO_OPCOES_FILTRO.COM_INTERSECAO;
    }

    getValorOpcao(registro) {
        this.opcoes = new Set();

        if (registro?.pedidoSustentacaoOral?.pedidosDetalhados) {
            registro.pedidoSustentacaoOral.pedidosDetalhados.forEach((pedido) => {
                if (pedido.advogados) {
                    pedido.advogados.forEach((advogado) => {
                        if (advogado.modoParticipacao !== MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo) {
                            if (
                                advogado.regOAB &&
                                advogado.regOAB.siglaUf !== undefined &&
                                advogado.regOAB.siglaUf !== ''
                            ) {
                                this.opcoes.add(advogado.regOAB.siglaUf);
                            } else {
                                this.opcoes.add(FiltroAdvogadoPreferenciaSustentacaoOralUfOab.opcaoSemValor);
                            }
                        }
                    });
                }
            });
        }

        return Array.from(this.opcoes);
    }
}
